"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleSelectField = SimpleSelectField;
exports.default = SelectField;

var _react = _interopRequireDefault(require("react"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pickBy = _interopRequireDefault(require("lodash/pickBy"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _Field = _interopRequireDefault(require("../Field"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SimpleSelectField(p) {
  var optionMapper = function optionMapper(k) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: k,
      value: k
    }, p.options[k]);
  },
      optionGroupMapper = function optionGroupMapper(k) {
    return /*#__PURE__*/_react.default.createElement("optgroup", {
      label: k,
      key: k
    }, Object.keys(p.optionGroups[k]).map(function (kk) {
      return /*#__PURE__*/_react.default.createElement("option", {
        key: kk,
        value: kk
      }, p.optionGroups[k][kk]);
    }));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)('control', {
      'has-icons-left': !!p.icon
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)('select', p.className, _defineProperty({
      'is-danger': p.danger,
      'is-success': p.success,
      'is-rounded': p.rounded
    }, "is-".concat(p.size), p.size))
  }, /*#__PURE__*/_react.default.createElement("select", _extends({}, p.selectProps, {
    value: p.value || '',
    onChange: p.onChange,
    onFocus: p.onFocus,
    onBlur: p.onBlur,
    ref: p.setRef,
    disabled: p.disabled
  }), p.placeholder && /*#__PURE__*/_react.default.createElement("option", {
    value: "",
    disabled: true
  }, p.placeholder), p.children || !(0, _isEmpty.default)(p.optionGroups) && Object.keys(p.optionGroups).map(optionGroupMapper) || Object.keys(p.options).map(optionMapper))), p.icon && /*#__PURE__*/_react.default.createElement("span", {
    className: "icon is-small is-left"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: p.icon
  })));
}

function SelectField(props) {
  return /*#__PURE__*/_react.default.createElement(_Field.default, _extends({}, props, {
    className: (0, _classnames2.default)('frikin-select-field', props.className)
  }), function (fieldProps) {
    return /*#__PURE__*/_react.default.createElement(SimpleSelectField, _extends({}, (0, _pickBy.default)(props, function (v, k) {
      return k !== 'className';
    }), fieldProps));
  });
}

SelectField.propTypes = SimpleSelectField.propTypes = {
  label: _propTypes.default.any,
  value: _propTypes.default.any,
  className: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  inline: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  danger: _propTypes.default.bool,
  success: _propTypes.default.bool,
  rounded: _propTypes.default.bool,
  options: _propTypes.default.any,
  optionGroups: _propTypes.default.object,
  size: _propTypes.default.oneOf(['small', 'medium', 'large', 'normal'])
};
SelectField.defaultProps = SimpleSelectField.defaultProps = {
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  options: {},
  size: 'normal'
};